import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDownloadConversationTranscript } from '@/entities/conversations';
import { DownloadByTemplateButton, type DownloadTemplateSelection } from '@/entities/download-template';

type Props = {
  dialogId: number;
};

export const DownloadTranscriptButton: FC<Props> = ({ dialogId }) => {
  const { t } = useTranslation(['dialogs']);
  const { mutate: download, isPending } = useDownloadConversationTranscript();

  const handleDownload = (selection: DownloadTemplateSelection) => {
    download({ id: dialogId, ...selection });
  };

  return (
    <DownloadByTemplateButton
      label={t('dialogs:downloadTranscript')}
      entityType="TRANSCRIPT"
      onDownload={handleDownload}
      isPending={isPending}
    />
  );
};
